module.exports = __webpack_public_path__ + "img/shi_wang_kou_pen.fde71c1c.png";